import { assert_type_enum } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP__field_data } from '@shared/types/types';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base } from '../../_base/FIELD__base';
import { ENUM__image_asset_category } from '../../ENUM__image_asset_category';
import { ENUM__image_transform } from '../../image/_enums/ENUM__image_transform';
import { FIELD__image_asset } from '../../image/FIELD__image_asset';
import { DECORATOR__class_serialization_tested } from '../_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_is_input } from '../_base/DECORATOR__field_is_input';
import { DECORATOR__field_not_linked } from '../_base/DECORATOR__field_not_linked';
import { FIELD__list_base_generic } from './FIELD__list_base_generic';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD__list_image_asset extends FIELD__list_base_generic<FIELD__image_asset> {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_LIST__IMAGE_ASSET;

  /*
   * FIELDS META
   */
  category!: ENUM__image_asset_category;

  /*
   * PROPERTIES
   */

  get graph_field__height() {
    if (this.meta.data__is_linked) return 1;

    return CONSTANTS__shared.GRAPH_FIELD_HEIGHT_IMAGE + 1;
  }

  images_are_initialized() {
    return this.items.every(item => item.image__is_initialized);
  }

  sort_items(items: FIELD__image_asset[]) {
    items.sort(FIELD__image_asset.sort_by_hash);
  }

  /*
   * METHODS
   */

  constructor() {
    super();

    this.item_connectable_type = ENUM__field_connectable_type.IMAGE;

    this.item_options.set('preprocessing_transform__current', [ENUM__image_transform.NONE]);
    this.item_options.set('preprocessing_transform__allowed', Object.values(ENUM__image_transform));
  }

  override _create_item_internal__default() {
    let out = new FIELD__image_asset();
    out.category = this.category;
    return out;
  }

  is_field_is_compatible_to_sync_with(other: FIELD__base): boolean {
    if (!super.is_field_is_compatible_to_sync_with(other)) return false;
    if (this.category == ENUM__image_asset_category.ANY) return true;

    let out = false;

    if (other instanceof FIELD__list_image_asset) {
      out = this.category == other.category || other.category == ENUM__image_asset_category.ANY;
    } else if (other instanceof FIELD__image_asset) {
      out = this.category == other.category;
    }

    return out;
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_enum(this.category, ENUM__image_asset_category);
  }

  /*
   *
   */

  store__can_deserialize_from_data(map: MAP__field_data) {
    if (!super.store__can_deserialize_from_data(map)) return false;

    let category = map.get_or_default('category', this.category);
    if (category != this.category) return false;

    return true;
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  find_item_from_list(item_to_compare: FIELD__image_asset) {
    return this.items.find_or_default(item => item.hash_sha256_content == item_to_compare.hash_sha256_content, FIELD__image_asset.CREATE_STUB());
  }
}
